import { render, staticRenderFns } from "./newCommerceForm.vue?vue&type=template&id=6f67923a&"
import script from "./newCommerceForm.vue?vue&type=script&lang=ts&"
export * from "./newCommerceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports